export default __webpack_public_path__ + "static/media/The Coder.deeab14e.jpg";